import React, { useState, useEffect } from "react";
import {
  View,
  TouchableOpacity,
  Text,
  StyleSheet,
  Modal,
  ScrollView,
  ActivityIndicator,
  Image,
} from "react-native";

import { useTranslation } from "react-i18next";
import { FontAwesome5 } from "@expo/vector-icons";
import Colors from "../../../Resources/Color";
import Fonts from "../../../Resources/Fonts";
import GlobalStyles from "../../../Resources/Styles";

import { observer } from "mobx-react";
import { Ionicons } from "@expo/vector-icons";
import { useScreenDimensions, useDevice } from "../../_layout";
import NoTranslateText from "../../Components/NoTranslateText";

import BlackPng from "../../../assets/BlackPng.png";
import { AspectRatios } from "../../../Resources/Constants";

import db from "../../Firestore/FirestoreConfig";
import { collection, addDoc, onSnapshot } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import CustomActivityIndicator from "../../Components/CustomActivityIndicator";
import { logoutCoachSession } from "../../auth/logoutCoachSession";

/* TEST MODE PRODUCT PRICES */
// export const ProductPrices = {
//   HASTA5: "price_1OpwTsIu8R9ZwWzDhwI9VpRj",
//   HASTA15: "price_1Opx7nIu8R9ZwWzD3LICyXpE",
//   HASTA30: "price_1OpxvFIu8R9ZwWzDfkO6vBv9",
//   HASTA50: "price_1Opx8BIu8R9ZwWzDfmdgs7nE",
//   MAS50: "price_1Opx95Iu8R9ZwWzDh6qZwv4z",
// };

/* REAL PRODUC PRICES */
export const ProductPrices = {
  HASTA5: "price_1QCT5RIu8R9ZwWzDlS6Dq1K8", //price_1Os2nbIu8R9ZwWzDj9BQqpqB",
  HASTA15: "price_1QCT96Iu8R9ZwWzDMFogwnoT", //"price_1Os2nwIu8R9ZwWzDDbnzam3i",
  HASTA30: "price_1QCTAyIu8R9ZwWzDs7YtVGFZ", //7"price_1Os2o8Iu8R9ZwWzDLz9q58Wh",
  HASTA50: "price_1QCTBcIu8R9ZwWzDimrWzyDa", //"price_1Os2oKIu8R9ZwWzD3uh68Rsx",
  MAS50: "price_1QCTCEIu8R9ZwWzDCKfLiJIk", //"price_1Os2oZIu8R9ZwWzD8meoNcr7",
};

const StripePayment = ({
  isVisible,
  onClose,
  coach,
  subscriptionEnded,
  maxClientsReached,
  maxClientsTrial,
}) => {
  const { t } = useTranslation();
  const { screenSize } = useScreenDimensions();
  const { isMobile } = useDevice();
  const auth = getAuth();
  const shouldShowUseAnotherAccount = subscriptionEnded === true;

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [isUseAnotherAccountHovered, setIsUseAnotherAccountHovered] =
    useState(false);

  const hasSale = false;

  useEffect(() => {
    if (subscriptionEnded) {
      // console.log("subscriptionEnded", coach.clients.length);
      if (coach.clients.length <= 5) {
        coach.setProperty("selectedRate", "upTo5Athletes-string");
      } else if (coach.clients.length > 5 && coach.clients.length <= 15) {
        coach.setProperty("selectedRate", "upTo15Athletes-string");
      } else if (coach.clients.length > 15 && coach.clients.length <= 30) {
        coach.setProperty("selectedRate", "upTo30Athletes-string");
      } else if (coach.clients.length > 30 && coach.clients.length <= 50) {
        coach.setProperty("selectedRate", "upTo50Athletes-string");
      } else {
        coach.setProperty("selectedRate", "moreThan50Athletes-string");
      }
    } else if (maxClientsReached) {
      // console.log("maxClientsReached", coach.clients.length);
      if (coach.clients.length === 5) {
        coach.setProperty("selectedRate", "upTo15Athletes-string");
      } else if (coach.clients.length === 15) {
        coach.setProperty("selectedRate", "upTo30Athletes-string");
      } else if (coach.clients.length === 30) {
        coach.setProperty("selectedRate", "upTo50Athletes-string");
      } else {
        coach.setProperty("selectedRate", "moreThan50Athletes-string");
      }
    } else if (maxClientsTrial) {
      // console.log("maxClientsTrial", coach.clients.length);
      if (coach.clients.length <= 5) {
        coach.setProperty("selectedRate", "upTo5Athletes-string");
      } else if (coach.clients.length > 5 && coach.clients.length <= 15) {
        coach.setProperty("selectedRate", "upTo15Athletes-string");
      } else if (coach.clients.length > 15 && coach.clients.length <= 30) {
        coach.setProperty("selectedRate", "upTo30Athletes-string");
      } else if (coach.clients.length > 30 && coach.clients.length <= 50) {
        coach.setProperty("selectedRate", "upTo50Athletes-string");
      } else {
        coach.setProperty("selectedRate", "moreThan50Athletes-string");
      }
    } else {
      if (coach.clients.length <= 5) {
        coach.setProperty("selectedRate", "upTo5Athletes-string");
      } else if (coach.clients.length > 5 && coach.clients.length <= 15) {
        coach.setProperty("selectedRate", "upTo15Athletes-string");
      } else if (coach.clients.length > 15 && coach.clients.length <= 30) {
        coach.setProperty("selectedRate", "upTo30Athletes-string");
      } else if (coach.clients.length > 30 && coach.clients.length <= 50) {
        coach.setProperty("selectedRate", "upTo50Athletes-string");
      } else {
        coach.setProperty("selectedRate", "moreThan50Athletes-string");
      }
    }
  }, []);

  const GoToStripeClientPortal = async () => {
    try {
      window.location.assign(
        "https://billing.stripe.com/p/login/9AQ3fW6andcNgne000",
      );
    } catch (error) {
      console.error("Error adding document: ", error);
    }
  };

  const GoToStripeBilling = async () => {
    try {
      setIsLoading(true);
      let price = "";
      if (coach.selectedRate === "upTo15Athletes-string") {
        price = ProductPrices.HASTA15;
      } else if (coach.selectedRate === "upTo30Athletes-string") {
        price = ProductPrices.HASTA30;
      } else if (coach.selectedRate === "upTo50Athletes-string") {
        price = ProductPrices.HASTA50;
      } else if (coach.selectedRate === "moreThan50Athletes-string") {
        price = ProductPrices.MAS50;
      } else {
        price = ProductPrices.HASTA5;
      }
      if (price !== "") {
        const docRef = await addDoc(
          collection(db, "customers", coach.id, "checkout_sessions"),
          {
            price: price,
            allow_promotion_codes: true,
            // promotion_code: hasSale
            //   ? coach.email === "jesusgh3105@gmail.com"
            //     ? "promo_1OyZ10Iu8R9ZwWzD43fvKBLy"
            //     : "promo_1OyHKbIu8R9ZwWzDAYrvxPLg"
            //   : null,
            success_url: window.location.origin,
            cancel_url: window.location.origin,
            automatic_tax: { enabled: true },
            tax_id_collection: true,
            locale: coach.coachLanguage,
          },
        );

        // Listen for changes to the newly created document
        onSnapshot(docRef, (snap) => {
          const { error, url } = snap.data();
          if (error) {
            // Handle the error appropriately
            alert(`An error occurred: ${error.message}`);
          }
          if (url) {
            // Redirect to the Stripe Checkout URL
            window.location.assign(url);
          }
        });
      }
    } catch (error) {
      setError(true);
      console.error("Error adding document: ", error);
    }
  };

  const Cancel = () => {
    onClose();
  };

  const logoutFromPaywall = async () => {
    if (isLoading) return;
    await logoutCoachSession({ auth, coach });
  };

  const SelectButton = () => {
    const [isHovered, setIsHovered] = useState(false);

    return (
      <TouchableOpacity
        onPress={maxClientsReached ? GoToStripeClientPortal : GoToStripeBilling}
        disabled={isLoading}
        style={{ marginTop: 10 }}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <View
          style={{
            backgroundColor: Colors.bubbleColor,
            borderRadius: 14,
            justifyContent: "center",
            borderColor: Colors.bubbleColor,
            height: 40,
            justifyContent: "center",
            alignItems: "center",
            opacity: 1,
          }}
        >
          {isLoading ? (
            <CustomActivityIndicator large={false} white={true} />
          ) : (
            <Text
              style={{
                textAlignVertical: "center",
                textAlign: "center",
                color: Colors.whiteColor,
                marginHorizontal: 10,
                fontWeight: isHovered ? "600" : "normal",
                fontSize: isHovered ? 15 : 14,
              }}
            >
              {maxClientsReached
                ? t("manageSubscription-string")
                : t("select-string")}
            </Text>
          )}
        </View>
      </TouchableOpacity>
    );
  };

  const WhatsIncludedBox = () => {
    const newWidth = 50;
    const newHeight = newWidth / AspectRatios.BlackPng;

    const BulletText = ({ text }) => {
      return (
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            marginBottom: 15,
          }}
        >
          <Ionicons
            name="checkmark-circle"
            size={20}
            color={Colors.bubbleColor}
            style={GlobalStyles.rowIcon}
          />
          <Text>{t(text)}</Text>
        </View>
      );
    };

    const Bottom = () => {
      const Icons = () => {
        return (
          <View
            style={{
              flexDirection: "row",
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
              marginTop: 20,
            }}
          >
            <FontAwesome5
              name="stripe"
              size={35}
              color="#9ea4ad"
              style={{
                marginRight: 40,
              }}
            />
            <FontAwesome5
              name="cc-visa"
              size={25}
              color="#9ea4ad"
              style={{
                marginRight: 40,
              }}
            />
            <FontAwesome5 name="google-pay" size={35} color="#9ea4ad" />
          </View>
        );
      };
      return (
        <View style={{ marginTop: 10 }}>
          <Text style={{ color: "#9ea4ad", fontSize: 12 }}>
            {t("stripeBottomText1-string")}
          </Text>
          <Text style={{ color: "#9ea4ad", fontSize: 12, marginTop: 5 }}>
            {t("stripeBottomText2-string")}
          </Text>
          <Icons />
        </View>
      );
    };
    return (
      <View
        style={{
          width: screenSize != "small" ? "50%" : "100%",
          paddingRight: screenSize != "small" ? 24 : 0,
          justifyContent: "center",
        }}
      >
        <View
          style={{
            flexDirection: "row",
            width: "100%",
            justifyContent: "center",
            marginBottom: 40,
            marginTop: 24,
          }}
        >
          <Image
            source={BlackPng}
            style={{
              width: newWidth,
              height: newHeight,
            }}
          />
        </View>

        {maxClientsReached && coach.subscriptionStatus === "active" ? (
          <>
            <View style={GlobalStyles.Spacer} />
            <Text style={{ marginBottom: 24 }}>
              {t("reachedMaxClientsStripeView-string")}
            </Text>
            <View style={GlobalStyles.Spacer} />
          </>
        ) : (
          <>
            <NoTranslateText style={{ fontWeight: "bold", marginBottom: 20 }}>
              {t("whatsIncluded-string")}
            </NoTranslateText>
            <BulletText text={"bulletText1-string"} />
            <BulletText text={"bulletText2-string"} />
            <BulletText text={"bulletText3-string"} />
            <BulletText text={"bulletText4-string"} />
            <BulletText text={"bulletText5-string"} />
          </>
        )}

        {screenSize != "small" && (
          <>
            <View style={styles.horizontalDivider} />
            <Bottom />
          </>
        )}
      </View>
    );
  };

  const SelectRateBox = () => {
    const RateRow = observer(({ rate, price }) => {
      const salePrice = Math.ceil(Number(price) * 0.3);
      const selectRate = () => {
        if (!isLoading && !maxClientsReached) {
          if (rate === "upTo5Athletes-string" && coach.clients.length <= 5) {
            coach.setProperty("selectedRate", rate);
          } else if (
            rate === "upTo15Athletes-string" &&
            coach.clients.length <= 15
          ) {
            coach.setProperty("selectedRate", rate);
          } else if (
            rate === "upTo30Athletes-string" &&
            coach.clients.length <= 30
          ) {
            coach.setProperty("selectedRate", rate);
          } else if (
            rate === "upTo50Athletes-string" &&
            coach.clients.length <= 50
          ) {
            coach.setProperty("selectedRate", rate);
          } else if (rate === "moreThan50Athletes-string") {
            coach.setProperty("selectedRate", rate);
          }
        }
      };

      const [isHovered, setIsHovered] = useState(false);

      return (
        <View>
          <TouchableOpacity
            onPress={selectRate}
            style={[
              GlobalStyles.touchableRow,
              {
                shadowColor: Colors.bubbleColor,
                borderWidth: coach && coach.selectedRate === rate ? 1 : 1,
                borderColor:
                  coach && coach.selectedRate === rate
                    ? Colors.blackColor
                    : isHovered
                      ? "rgba(0, 0, 0, 0.5)"
                      : Colors.borderColor,
                justifyContent: "space-between",
                marginBottom: 10,
              },
            ]}
            onMouseEnter={() => !isMobile && setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <Text style={Fonts.medium16}>{t(rate)}</Text>

            {hasSale ? (
              <View style={{ flexDirection: "row" }}>
                <Text
                  style={[
                    Fonts.medium16,
                    {
                      marginRight: 10,
                      color: "red",
                    },
                  ]}
                >
                  {/* {salePrice} € */}
                  {t("priceWithCurrency-string", { price: salePrice })}
                </Text>
                <Text
                  style={[
                    Fonts.medium16,
                    {
                      textDecorationLine: "line-through",
                      // marginRight: 5,
                      // textDecorationColor: "red",
                    },
                  ]}
                >
                  {/* {price} € */}
                  {t("priceWithCurrency-string", { price: price })}
                </Text>
                <Text
                  style={[
                    Fonts.medium16,
                    {
                      // textDecorationColor: "red",
                    },
                  ]}
                >
                  {" "}
                  {t("pricePerMonthDiscount-string")}
                </Text>
              </View>
            ) : (
              <View style={{ alignItems: "flex-end" }}>
                <Text style={Fonts.medium16}>
                  {t("pricePerMonth-string", { price: price })}
                </Text>
                {rate !== "moreThan50Athletes-string" && (
                  <>
                    {rate === "upTo5Athletes-string" ? (
                      <Text
                        style={[
                          Fonts.medium12,
                          { color: Colors.grayColor, marginTop: 2 },
                        ]}
                      >
                        {t("pricePerAthlete-string", { price: 1.99 })}
                      </Text>
                    ) : rate === "upTo15Athletes-string" ? (
                      <Text
                        style={[
                          Fonts.medium12,
                          { color: Colors.grayColor, marginTop: 2 },
                        ]}
                      >
                        {t("pricePerAthlete-string", { price: 1.67 })}
                      </Text>
                    ) : rate === "upTo30Athletes-string" ? (
                      <Text
                        style={[
                          Fonts.medium12,
                          { color: Colors.grayColor, marginTop: 2 },
                        ]}
                      >
                        {t("pricePerAthlete-string", { price: 1.33 })}
                      </Text>
                    ) : (
                      <Text
                        style={[
                          Fonts.medium12,
                          { color: Colors.grayColor, marginTop: 2 },
                        ]}
                      >
                        {t("pricePerAthlete-string", { price: 1.19 })}
                      </Text>
                    )}
                  </>
                )}
              </View>
            )}
          </TouchableOpacity>
        </View>
      );
    });
    return (
      <View
        style={{
          width: screenSize != "small" ? "50%" : "100%",
          paddingLeft: screenSize != "small" ? 24 : 0,
          justifyContent: "center",
          marginBottom: screenSize != "small" ? 0 : 24,
        }}
      >
        <RateRow rate={"upTo5Athletes-string"} price={"9.99"} />
        <RateRow rate={"upTo15Athletes-string"} price={"24.99"} />
        <RateRow rate={"upTo30Athletes-string"} price={"39.99"} />
        <RateRow rate={"upTo50Athletes-string"} price={"59.99"} />
        <RateRow rate={"moreThan50Athletes-string"} price={"89.99"} />
        <SelectButton />
      </View>
    );
  };

  const Sale = () => {
    const CountdownTimer = () => {
      const calculateTimeLeft = () => {
        // Get the current year to construct the target date
        const year = new Date().getUTCFullYear();
        // Assuming the targetDate is in UTC
        const targetDate = Date.UTC(year, 3, 1, 10, 0, 0); // Note: Months are 0-indexed
        // Get the current time in UTC
        const now = new Date().getTime();

        // Calculate the difference in milliseconds
        const difference = targetDate - now;

        // Calculate total time left
        let timeLeft = {};

        if (difference > 0) {
          timeLeft = {
            days: Math.floor(difference / (1000 * 60 * 60 * 24)),
            hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
            minutes: Math.floor((difference / 1000 / 60) % 60),
            seconds: Math.floor((difference / 1000) % 60),
          };
        }

        return timeLeft;
      };

      const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

      useEffect(() => {
        const timer = setTimeout(() => {
          setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => clearTimeout(timer);
      });

      return (
        <View style={{ marginTop: 10 }}>
          <Text style={{ fontSize: 20 }}>
            {timeLeft.days || "0"}d : {timeLeft.hours || "0"}h :{" "}
            {timeLeft.minutes || "0"}m : {timeLeft.seconds || "0"}s
          </Text>
        </View>
      );
    };

    return (
      hasSale && (
        <View style={{ alignItems: "center" }}>
          <View
            style={{
              width: "100%",
              marginTop: 24,
              backgroundColor: Colors.bubbleColor,
              alignItems: "center",
            }}
          >
            <Text
              style={[
                Fonts.medium22,
                { padding: 10, color: Colors.whiteColor },
              ]}
            >
              {coach.email === "jesusgh3105@gmail.com"
                ? "-70% DE DESCUENTO DURANTE 3 MESES"
                : "-70% DE DESCUENTO DURANTE EL PRIMER MES"}
            </Text>
          </View>
          <CountdownTimer />
        </View>
      )
    );
  };

  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={isVisible}
      onRequestClose={(!isLoading || !subscriptionEnded) && onClose}
    >
      <View style={GlobalStyles.centeredView}>
        <TouchableOpacity
          onPress={Cancel}
          style={GlobalStyles.touchableBackground}
          disabled={isLoading || subscriptionEnded}
        >
          <View />
        </TouchableOpacity>
        <View
          style={[
            styles.modalView,
            {
              position: "absolute",
              maxHeight: "90%",
              width: "90%",
              maxWidth: screenSize != "small" ? 800 : "90%",
              alignSelf: "center",
            },
          ]}
          onStartShouldSetResponder={() => false}
        >
          {/* <Sale /> */}
          <ScrollView
            style={{ flex: 1, padding: 24 }}
            contentContainerStyle={{ flex: 1 }}
            showsVerticalScrollIndicator={false}
          >
            <View
              style={{
                flexDirection: screenSize != "small" ? "row" : "column",
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <WhatsIncludedBox />
              {screenSize != "small" && <View style={styles.verticalDivider} />}
              <SelectRateBox />
            </View>
          </ScrollView>
          {shouldShowUseAnotherAccount && (
            <View style={styles.footerSecondaryAction}>
              <TouchableOpacity
                onPress={logoutFromPaywall}
                disabled={isLoading || coach?.isOffline}
                onMouseEnter={() =>
                  !isMobile && setIsUseAnotherAccountHovered(true)
                }
                onMouseLeave={() => setIsUseAnotherAccountHovered(false)}
                style={{ paddingVertical: 4 }}
              >
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    opacity:
                      isLoading || coach?.isOffline
                        ? 0.45
                        : isUseAnotherAccountHovered
                          ? 0.6
                          : 0.8,
                  }}
                >
                  <Ionicons
                    name="log-out-outline"
                    size={14}
                    color={Colors.darkgrayColor}
                  />
                  <Text
                    style={[
                      Fonts.medium12,
                      {
                        color: Colors.darkgrayColor,
                        marginLeft: 6,
                        textAlign: "center",
                      },
                    ]}
                  >
                    {t("useAnotherAccount-string")}
                  </Text>
                </View>
              </TouchableOpacity>
            </View>
          )}
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalView: {
    borderRadius: 18,
    backgroundColor: Colors.whiteColor,
  },
  verticalDivider: {
    width: 1,
    // maxHeight: screenHeight * 0.5,
    backgroundColor: Colors.borderColor,
  },
  horizontalDivider: {
    height: 1,
    // maxHeight: screenHeight * 0.5,
    backgroundColor: Colors.borderColor,
    marginTop: 40,
  },
  footerSecondaryAction: {
    paddingHorizontal: 24,
    paddingBottom: 14,
    paddingTop: 4,
    alignItems: "center",
  },
});

export default StripePayment;
